import { currencies } from '@/components/global/options/currencies.jsx';

export const currencyChoices = currencies.map(currency => ({ id: currency, name: currency }));
